import { render, staticRenderFns } from "./DashboardItems.vue?vue&type=template&id=5cef717e&"
import script from "./DashboardItems.vue?vue&type=script&lang=js&"
export * from "./DashboardItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports